<template>      
    <div class="content">
        <div class="row">
            <div class="col-12">                 
                <h3>{{ this.translate_array["title_modal"] }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <hr><hr>
            </div>
        </div>        
        <div class="row">
            <div class="col-6 border-right">
                <h3>{{ this.translate_array["select"] }}</h3>
            </div>
            <div class="col-6">
                <h3>{{ this.translate_array["selected"] }}</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <hr>
            </div>
        </div>
        <div class="row"> 
           <div class="col-6 border-right">
               <div class="row">
                   <div class="col-12 input-group mb-3">                                               
                        <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="button-addon2" v-model="filter"  @change="search()">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary btn--green" type="button" id="button-addon2">Search</button>
                        </div>                        
                   </div>
               </div>
               <div class="row m-1 og-row" v-for="organizationalUnit in this.internalselectable_itemsFiltered.slice(0, this.itemPerPage)" v-bind:key=organizationalUnit.id @click="addOg(organizationalUnit)">
                   <div class="col-1">
                       <i class="fa fa-arrow-right" style="color: green;" aria-hidden="true"></i>
                   </div>
                   <div class="col-11">{{ organizationalUnit.name }} <span v-if="organizationalUnit.category">({{ translate_array["category"] }} {{organizationalUnit.category}})</span></div>
                </div>
                <div class="row" v-if="this.internalselectable_itemsFiltered != null ? this.itemPerPage < this.internalselectable_itemsFiltered.length : false">
                    <div class="col-1"></div>
                    <div class="col-11">...</div>
                </div>
                <div class="row mt-2" v-if="this.internalselectable_itemsFiltered != null ? this.itemPerPage < this.internalselectable_itemsFiltered.length : false">
                    <div class="col-12">                        
                        <button type="button" class="btn btn--primary" @click="addItemPerPage()">{{ this.translate_array["showMore"] }}</button>
                    </div>
                </div>
           </div>                            
           <div class="col-6">
                <div class="row m-1 og-row" v-for="personOrganizationalUnit in this.internalselected_items" v-bind:key=personOrganizationalUnit.id @click="removeOg(personOrganizationalUnit)">                
                    <div class="col-1">
                       <i class="fa fa-arrow-left" style="color: red;" aria-hidden="true"></i>
                   </div>
                    <div class="col-11">{{ personOrganizationalUnit.name }} <span v-if="personOrganizationalUnit.category">({{ translate_array["category"] }} {{personOrganizationalUnit.category}})</span> </div>          
                </div>                                
           </div>
       </div>
       <div class="row">
           <div class="col-12 text-right">
                <button type="button" class="btn btn--secondary btn--danger" @click="close()">Annulla</button>
                <button type="button" class="btn btn--success" @click="confirm()">Associa</button>
            </div>           
       </div>
    </div>
</template>

<script>
  export default {  
      data(){
      return {
          filter : null,
          itemPerPage: 7,
          internalselectable_items: [],
          internalselected_items: [],
          internalselectable_itemsFiltered : []
      }
    },    
    mounted() {

          this.internalselectable_items = this.selectable_items;
          this.internalselected_items = this.selected_items;
          this.internalselectable_itemsFiltered = this.internalselectable_items != null ? this.internalselectable_items : []; 
          
          if (this.internalselected_items != null && this.internalselected_items.length > 0){
              for(var i = 0; i < this.internalselected_items.length; i++){
                    var og = this.internalselected_items[i];
                    this.internalselectable_items = this.removeItemAll(this.internalselectable_items, og.id);            
                    this.internalselectable_itemsFiltered = this.removeItemAll(this.internalselectable_itemsFiltered, og.id);            
              }
          }
        },
    methods:{
        search(){            
            this.itemPerPage = 7;
            
            if (this.filter == "" || this.filter == null){
                this.internalselectable_itemsFiltered = this.internalselectable_items;
                return;
            }
            
            if (this.internalselectable_items != null && this.internalselectable_items.length > 0){

                var resultSet = [];
                for(var i=0; i < this.internalselectable_items.length; i++){
                    if(this.internalselectable_items[i].name.toLowerCase().includes(this.filter.toLowerCase())){
                        resultSet = resultSet.concat(this.internalselectable_items[i]);
                    }
                }
            }

            if (resultSet == null){
                this.internalselectable_itemsFiltered = [];
            } else {
                this.internalselectable_itemsFiltered = resultSet;
            }            
        },
        addItemPerPage(){
           this.itemPerPage += 10;
        },
        addOg(og){
            if (this.internalselected_items == null){
                this.internalselected_items = [];
            }
            this.internalselected_items = this.internalselected_items.concat(og);
            this.internalselectable_items = this.removeItemAll(this.internalselectable_items, og.id);            
            this.internalselectable_itemsFiltered = this.removeItemAll(this.internalselectable_itemsFiltered, og.id);
        },
        removeOg(og){
            
            if (this.internalselectable_items == null){
                this.internalselectable_items = [];
            }
            
            this.internalselectable_items = this.internalselectable_items.concat(og);            
            if(this.filter == null || this.filter == "" || og.name.includes(this.filter.toLowerCase())){                
                this.internalselectable_itemsFiltered = this.internalselectable_itemsFiltered.concat(og);
            }
            
            this.internalselected_items = this.removeItemAll(this.internalselected_items, og.id);            
        },
        removeItemAll(arr, value) {
            var i = 0;
            if (arr == null){
                return [];
            }
            while (i < arr.length) {
                if (arr[i].id === value) {
                    arr.splice(i, 1);
                } else {
                    ++i;
                }
            }
            return arr;
        },
        close(){
            app.__vue__.$refs.vue_popup.active = false;
        },
        confirm(){
            axios.put(this.url_update, {"selectedItems" : this.internalselected_items}).then((response) => {
                Vue.$toast.open({
                    message: 'Salvataggio riuscito',
                    type: 'success',
                    position: 'top-right'
                });                
                location.reload();
            });
        },        
    },      
    props: {
      selectable_items: {
        type: Array,
        required: false
      },
      selected_items: {
        type: Array,
        required: false
      },            
      url_update:{
          type: String,
          required: false
      },
      translate_array:{
          type: Object,
          required: false
      }
    }
  }
</script>
<style>
    .og-row{
        cursor: pointer
    }
    .og-row:hover{
        text-decoration: underline;
    }
</style>